// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3506":"cf98fbca12d1302b","4193":"3972c3c872c30ed7"}[chunkId] + ".css";
};